export const categories = [
  {
    id: "saishizhibo",
    name: "赛事直播",
    icon: "ri-live-line",
    description: "实时观看全球顶级体育赛事，足球、篮球、网球、电竞等热门项目一网打尽。高清画质、专业解说，随时随地畅享观赛体验。",
    color: "bg-red-500",
    image: "https://readdy.ai/api/search-image?query=Professional%20sports%20stadium%20atmosphere%20with%20bright%20stadium%20lights%20and%20excited%20crowd%2C%20dynamic%20sports%20photography%20style%2C%20warm%20golden%20and%20white%20lighting%2C%20clean%20composition%2C%20minimalist%20background%20with%20sports%20arena%20silhouette&width=800&height=500&seq=yunsports-cat-live&orientation=landscape",
  },
  {
    id: "yundongkecheng",
    name: "运动课程",
    icon: "ri-book-open-line",
    description: "由专业教练团队打造的体系化运动课程，涵盖瑜伽、普拉提、搏击、舞蹈等多种类型，从入门到进阶满足不同水平需求。",
    color: "bg-orange-500",
    image: "https://readdy.ai/api/search-image?query=Modern%20fitness%20studio%20with%20people%20practicing%20yoga%20and%20exercise%2C%20bright%20natural%20lighting%2C%20clean%20wooden%20floor%2C%20minimalist%20interior%20design%2C%20warm%20atmosphere%2C%20professional%20fitness%20photography&width=800&height=500&seq=yunsports-cat-course&orientation=landscape",
  },
  {
    id: "jianshenjihua",
    name: "健身计划",
    icon: "ri-heart-pulse-line",
    description: "个性化健身计划定制，科学训练方案助你高效达成目标。减脂、增肌、塑形、体能提升，AI智能匹配最适合你的训练方案。",
    color: "bg-green-500",
    image: "https://readdy.ai/api/search-image?query=Personal%20trainer%20coaching%20client%20in%20modern%20gym%2C%20professional%20fitness%20equipment%20in%20background%2C%20bright%20clean%20lighting%2C%20motivational%20atmosphere%2C%20warm%20neutral%20tones%2C%20fitness%20lifestyle%20photography&width=800&height=500&seq=yunsports-cat-fitness&orientation=landscape",
  },
  {
    id: "tiyuzixun",
    name: "体育资讯",
    icon: "ri-newspaper-line",
    description: "汇聚全球最新体育资讯，赛事战报、转会动态、运动员专访、深度分析，让你第一时间掌握体育圈大小事。",
    color: "bg-amber-500",
    image: "https://readdy.ai/api/search-image?query=Sports%20journalist%20working%20at%20modern%20newsroom%20with%20multiple%20screens%20showing%20sports%20highlights%2C%20professional%20workspace%2C%20warm%20lighting%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=yunsports-cat-news&orientation=landscape",
  },
];

export const categorySlugMap: Record<string, string> = {
  saishizhibo: "赛事直播",
  yundongkecheng: "运动课程",
  jianshenjihua: "健身计划",
  tiyuzixun: "体育资讯",
};